import { cosemApi } from '@services/providers/cosem';
import { TicketType, TicketTypeToCreate, TicketTypeToUpdate } from './ticket-types.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

const ticketTypesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getPaginatedTicketTypes: build.mutation<
            ApiPaginationResponse<TicketType>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/ticket-types/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<TicketType>) => response
        }),
        getArchivedPaginatedTicketTypes: build.mutation<
            ApiPaginationResponse<TicketType>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/ticket-types/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<TicketType>) => response
        }),
        updateTicketType: build.mutation<ApiResponse<TicketType>, TicketTypeToUpdate>({
            query: (ticketType: TicketTypeToUpdate) => {
                return {
                    url: `/member/ticket-types/${ticketType.id}`,
                    method: 'PUT',
                    body: ticketType
                };
            },
            transformResponse: (response: ApiResponse<TicketType>) => response
        }),
        createTicketType: build.mutation<ApiResponse<TicketType>, TicketTypeToCreate>({
            query: (ticketType: TicketTypeToCreate) => {
                return {
                    url: `/member/ticket-types`,
                    method: 'POST',
                    body: ticketType
                };
            },
            transformResponse: (response: ApiResponse<TicketType>) => response
        }),
        deleteTicketType: build.mutation<ApiResponse<TicketType>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/ticket-types/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<TicketType>) => response
        }),
        toggleArchiveTicketType: build.mutation<ApiResponse<TicketType>, { id: string|number, archived: boolean }>({
            query: ({ id, archived }) => {
                return { 
                    url: `/member/ticket-types/${id}/archive`, 
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<TicketType>) => response
        }),
    })
});

export const {
    useGetPaginatedTicketTypesMutation,
    useGetArchivedPaginatedTicketTypesMutation,
    useUpdateTicketTypeMutation,
    useCreateTicketTypeMutation,
    useDeleteTicketTypeMutation,
    useToggleArchiveTicketTypeMutation
} = ticketTypesApi;
